import React from 'react'

const Homesection4 = () => {
    return (
        <div className=' w-[100%] h-[80vh] sm:pb-12 md:min-h-[100vh] sm:w-[auto] sm:h-[auto] xsm:h-[auto] xsm:pb-10 xsm:w-[auto] md:py-12 sm:mt-12 xsm:mt-12 xl:mt-5 grid flex-col justify-center items-center'>

            <div className="text-content grid justify-center items-center text-center ">

                <p className=' font-semibold text-[#00646b]'>SERVICES</p>
                <h1 className=' font-bold xl:text-4xl md:text-4xl sm:text-3xl xsm:text-3xl'>What's Intresting about dog's</h1>
            </div>

            <div className="w-[100%] h-[auto]  sm:p-5 xsm:p-4 xsm:gap-6 sm:gap-5 sm:mt-10 xsm:mt-12 service-block grid xl:grid-cols-3 items-center justify-center xl:gap-10 md:gap-5 md:p-10 xl:p-20 md:grid-cols-2 ">

                <div className="service-boxes">
                    <div className="icon">
                    <i class="fas text-[#00646b] text-2xl fa-paw"></i>
                    </div>
                    <div className="text-p">
                        <p className='font-semibold my-2'>Jealousy in the air!</p>
                    </div>
                    <div className="sec-p">
                        <p>At different stage of your life, you have a unique set of concerns, & we understand you. We provide professional advice.</p>
                    </div>
                </div>

                <div className="service-boxes">
                    <div className="icon">
                    <i class="fas text-[#00646b] text-2xl fa-home"></i>
                    </div>
                    <div className="text-p">
                        <p className='font-semibold my-2'>Running in circles</p>
                    </div>
                    <div className="sec-p">
                        <p>At different stage of your life, you have a unique set of concerns, & we understand you. We provide professional advice.</p>
                    </div>
                </div>

                <div className="service-boxes">
                    <div className="icon">
                    <i class="fas text-[#00646b] text-2xl fa-dog"></i>
                    </div>
                    <div className="text-p">
                        <p className='font-semibold my-2'>The most popular breed in the US</p>
                    </div>
                    <div className="sec-p">
                        <p>At different stage of your life, you have a unique set of concerns, & we understand you. We provide professional advice.</p>
                    </div>
                </div>

                <div className="service-boxes">
                    <div className="icon">
                    <i class="fas text-[#00646b] text-2xl fa-medal"></i>
                    </div>
                    <div className="text-p">
                        <p className='font-semibold my-2'>Superdog</p>
                    </div>
                    <div className="sec-p">
                        <p>At different stage of your life, you have a unique set of concerns, & we understand you. We provide professional advice.</p>
                    </div>
                </div>

                <div className="service-boxes">
                    <div className="icon">
                    <i class="fas text-[#00646b] text-2xl fa-trophy"></i>
                    </div>
                    <div className="text-p">
                        <p className='font-semibold my-2'>The Oldest dog ever</p>
                    </div>
                    <div className="sec-p">
                        <p>At different stage of your life, you have a unique set of concerns, & we understand you. We provide professional advice.</p>
                    </div>
                </div>

                <div className="service-boxes">
                    <div className="icon">
                    <i class="fas text-[#00646b] text-2xl fa-heartbeat"></i>
                    </div>
                    <div className="text-p">
                        <p className='font-semibold my-2'>Lower your blood pressure</p>
                    </div>
                    <div className="sec-p">
                        <p>At different stage of your life, you have a unique set of concerns, & we understand you. We provide professional advice.</p>
                    </div>
                </div>

            </div>




        </div>
    )
}

export default Homesection4